import { LogOut, User as UserIcon } from "lucide-react";
import {
  Avatar,
  AvatarFallback,
} from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/hooks/useAuth";
import { useHashRoute } from "@/hooks/useHashRoute";

export function TopBar() {
  const { user, signOut } = useAuth();
  const { navigate } = useHashRoute();
  const email = user?.email ?? "";
  const initial = email ? email[0]!.toUpperCase() : "?";

  return (
    <header className="flex items-center justify-between border-b border-slate-800 px-4 py-3 sm:px-6">
      <a
        href="#/"
        className="font-mono text-sm tracking-tight text-slate-200 hover:text-slate-50"
      >
        Foundry VTT
      </a>
      {email && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              className="rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950"
              aria-label="account menu"
            >
              <Avatar>
                <AvatarFallback>{initial}</AvatarFallback>
              </Avatar>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel className="font-mono normal-case">{email}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onSelect={() => navigate("#/admin")}>
              <UserIcon className="h-4 w-4" />
              Admin portal
            </DropdownMenuItem>
            <DropdownMenuItem
              onSelect={async () => {
                await signOut();
                navigate("#/login");
              }}
            >
              <LogOut className="h-4 w-4" />
              Sign out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </header>
  );
}
